/** Hyundai dealer new-car stock (external OEM tool). */
export const HYUNDAI_NEW_STOCK_URL =
  "https://lager.hyundai.se/?customer=private&dealerSite=bilspektrum";
